module.exports = __webpack_public_path__ + "img/close.d48c8032.svg";